module.exports = __webpack_public_path__ + "assets/img/20_969.8084961a.jpg";